export const updateSearchTerm = (term) => ({ type: 'UPDATE_SEARCH_TERM', term });
export const performSearch = () => ({ type: 'PERFORM_SEARCH' });
export const clearSearch = () => ({ type: 'CLEAR_SEARCH' });
